import {api, routes} from "@/plugins/axios";

export function useTags() {
    const getTags = (organizationSlug, page = 1, perPage = 10, search = '') => {
        return api.get(routes.tags.list(organizationSlug, page, perPage, search))
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    };

    return {
        getTags
    }
}
